import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faUndo } from '@fortawesome/pro-solid-svg-icons';

import { overrideShape } from '../../helpers/table_override_helper';

export default class NormalTableControls extends React.Component {
  static propTypes = {
    allowColumnEditing: PropTypes.bool.isRequired,
    allowRowEditing: PropTypes.bool.isRequired,
    override: overrideShape,

    onEditStart: PropTypes.func.isRequired,
    onOverrideReset: PropTypes.func.isRequired
  }

  render() {
    const dimensions = [];

    if (this.props.allowRowEditing) {
      dimensions.push('Rows');
    }

    if (this.props.allowColumnEditing) {
      dimensions.push('Columns');
    }

    const editLabel = `Edit ${dimensions.join('/')}`;

    return (
      <React.Fragment>
        <span className="click-target" name="reset" onClick={this.props.onOverrideReset}>
          {this.renderResetLabel()}
        </span>

        <span className="click-target" name="edit-table" onClick={this.props.onEditStart}>
          <FontAwesomeIcon icon={faPencilAlt} />
          {editLabel}
        </span>
      </React.Fragment>
    );
  }

  // Always render the wrapper for the sake of layout, even if there is no content
  renderResetLabel() {
    if (!this.props.override) {
      return null;
    }

    return <React.Fragment>
      <FontAwesomeIcon icon={faUndo} />
      Reset
    </React.Fragment>;
  }
}
